<template>
  <div v-if="content.input" class="msg-container">
    <div class="msg flex py-5 owner">
      <div class="msg-profile relative">
        <img
          v-if="content.answerAvatar"
          :src="content.answerAvatar"
          class="w-10 h-10 rounded-full object-cover border border-purple-200"
        />
        <AvatarIcon v-else class="w-10 h-10 rounded-full object-cover border border-purple-200" />
      </div>
      <div class="msg-content">
        <div
          v-for="(option, index) in content.options"
          :key="index"
          :class="['msg-text', option === content.input ? 'selected' : '']"
          v-text="option"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AvatarIcon from './assets/avatarIcon.vue';

@Component({
  components: {
    AvatarIcon
  }
})
export default class RedioInput extends Vue {
  @Prop({ type: Object }) content!: Content & { answerAvatar: string };
}
</script>

<style scoped>
.owner {
  @apply flex-row-reverse;
}

.owner .msg-content {
  @apply items-end flex flex-col mr-4 relative rounded-md;
}

.msg-text {
  @apply relative shadow-sm min-h-48 w-full prose prose-lg rounded-md flex items-center bg-white mb-4 px-4;
  border: 1px solid #d0d0d6;
}

.msg-text:last-child {
  @apply mb-0;
}

.msg-text.selected {
  @apply border border-motif-500 rounded-md bg-motif-100;
}

.owner .msg-text::before {
  @apply -right-1;
  left: initial;
}
</style>
